import { useQuery } from "@tanstack/react-query"
import axios from "axios";

const fetchPageData =(tag)=>{
    const beURL = localStorage.getItem('BeURL');

    return axios.get(`${beURL}tag/pages/${tag}`,{
    }).then(res => res.data); 
}

export const useTagPages=(enabled, tag)=>{
    return useQuery({
        queryKey:[`tag-${tag}-Pages`],
        queryFn:()=> fetchPageData(tag),
        enabled,
    })
}